import { render, staticRenderFns } from "./MdProductMain.vue?vue&type=template&id=fa889842&scoped=true&"
import script from "./MdProductMain.vue?vue&type=script&lang=js&"
export * from "./MdProductMain.vue?vue&type=script&lang=js&"
import style0 from "./MdProductMain.vue?vue&type=style&index=0&id=fa889842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa889842",
  null
  
)

export default component.exports